import { render, staticRenderFns } from "./ResidentPaymentHistoryTab.vue?vue&type=template&id=9b0956d8&scoped=true&"
import script from "./ResidentPaymentHistoryTab.vue?vue&type=script&lang=ts&"
export * from "./ResidentPaymentHistoryTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0956d8",
  null
  
)

export default component.exports